import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Setup2FA from './pages/Setup2FA';
import Register from './pages/Register';
import Arcade from './pages/Arcade';
import AdminLayout from './pages/admin/AdminLayout';
import Users from './pages/admin/Users';
import Tools from './pages/admin/Tools';
import Roles from './pages/admin/Roles';
import AccessLogs from './pages/admin/AccessLogs';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={
            <ProtectedRoute><ChangePassword /></ProtectedRoute>
          } />
          <Route path="/" element={
            <ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>
          } />
          <Route path="/setup-2fa" element={<Setup2FA />} />
          <Route path="/register/:token" element={<Register />} />
          <Route path="/arcade" element={
            <ProtectedRoute><Layout><Arcade /></Layout></ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute adminOnly><Layout><AdminLayout /></Layout></ProtectedRoute>
          }>
            <Route index element={<Navigate to="/admin/users" replace />} />
            <Route path="users" element={<Users />} />
            <Route path="tools" element={<Tools />} />
            <Route path="roles" element={<Roles />} />
            <Route path="logs" element={<AccessLogs />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
